try{self['workbox:cacheable-response:4.3.1']&&_()}catch(e){}// eslint-disable-line